module.exports = __webpack_public_path__ + "static/media/orderstatus.0994ba6e.png";